import { PayloadAction } from '@reduxjs/toolkit';
import { DTO__grid2d } from '@shared/dto/grid2d/DTO__grid2d';
import { ENUM__redux_action } from '../../_base/ENUM__redux_action';
import { FN_SLICE__grid2d_recreate } from '../_methods/FN_SLICE__grid2d_recreate';
import { STATE__grid2d } from '../STATE__grid2d';

export const LOCAL__grid2d_upsert = (items: DTO__grid2d[]): PayloadAction<DTO__grid2d[]> => ({
  type: ENUM__redux_action.GRID2D_UPSERT,
  payload: items,
});

export function init_local_grid2d_upsert(state: STATE__grid2d, action: PayloadAction<DTO__grid2d[]>) {
  let items = action.payload;

  if (items.is_empty()) return;

  for (let item of items) {
    let grids2d_map = state.grids2d_map;

    grids2d_map.set(item._id, item);

    state.grids2d_map = grids2d_map;
  }

  //refresh map to trigger re-render
  FN_SLICE__grid2d_recreate(state);
}
